import React from 'react';
import ReactDOM from 'react-dom/client';
import { configure } from 'wortou/browser';
import App from './App';

configure({
  clientId: import.meta.env.VITE_WORTOU_CLIENT_ID,
  platformUrl: import.meta.env.VITE_WORTOU_PLATFORM_URL || undefined,
  popupMode: 'redirect',
  autoLogin: true,
  autoPayment: true,
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);